import z from 'zod';

/**
 * Common module-related job input (question generation, shuffle, validation, study generation).
 * Used as the `data` payload (JSON string) for job types: QUESTION_GENERATION, SHUFFLE_QUESTIONS,
 * VALIDATE_QUESTIONS, VALIDATE_QUESTIONS_GPT, STUDY_GENERATION.
 */
export const commonModuleJobDataSchema = z.object({
  moduleId: z.string().min(1, 'Module ID is required'),
  topics: z.array(z.string().min(1, 'Topic cannot be empty')).optional().default([]),
  difficulties: z.array(z.number().int().min(1).max(5)).optional().default([1, 2, 3, 4, 5]),
  count: z.number().int().min(1).optional(),
  runLimit: z.number().int().min(1).max(1000).optional(),
});

export interface CommonModuleJobData extends z.infer<typeof commonModuleJobDataSchema> {}
export function validateCommonModuleJobData(data: string): CommonModuleJobData {
  return commonModuleJobDataSchema.parse(JSON.parse(data));
}
